import axios from 'axios';
import Cookies from 'js-cookie';
import { COOKIE_NAMES, PAYMENT_API_ENDPOINT } from '../constants';
import { AxiosUtil } from '../utils/axios';

const getPaymentV2Endpoint = () => {
  if (PAYMENT_API_ENDPOINT.endsWith('/api/v2')) {
    return PAYMENT_API_ENDPOINT;
  }
  if (PAYMENT_API_ENDPOINT.endsWith('/api/v1')) {
    return PAYMENT_API_ENDPOINT.replace(/\/api\/v1$/, '/api/v2');
  }
  return `${PAYMENT_API_ENDPOINT.replace(/\/$/, '')}/v2`;
};

const http = axios.create({
  baseURL: getPaymentV2Endpoint(),
});

const accessToken = Cookies.get(COOKIE_NAMES.COOKIE_ACCESS_TOKEN);
if (!http.defaults.headers['Authorization'] && accessToken) {
  http.defaults.headers['Authorization'] = `Bearer ${accessToken}`;
}

AxiosUtil.handleAutoRefreshToken(http);
http.interceptors.response.use((response: { data: any }) => response.data);

export default http;
